var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVTrackLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 48V42.9333L4 38.9333V48H0ZM11 48V32.2667L15 28.2667V48H11ZM22 48V28.2667L26 32.3333V48H22ZM33 48V32.3333L37 28.3333V48H33ZM44 48V21.6L48 17.6V48H44ZM0 32.2667V26.6L18.6667 8.06667L29.3333 18.7333L48 0V5.66667L29.3333 24.4L18.6667 13.7333L0 32.2667Z",
    fill: "#1773BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVTrackLogo);
export default __webpack_public_path__ + "static/media/vTrackLogo.4e1ac9a464e84a95ac77a993cd7ab726.svg";
export { ForwardRef as ReactComponent };